/* VB · Ficha de producto (sections/vb-main-product.liquid + snippets/vb-sticky-atc.liquid).
   Galería (miniaturas, flechas mostrar/ocultar, swipe con puntos) + visor a pantalla completa (<dialog>: flechas, ←/→,
   swipe, contador, cierre con X/fondo/Esc, foco devuelto y scroll bloqueado) · pack y cantidad INDEPENDIENTES
   (pack de q unidades × n → quantity = q·n; total de pack con window.VBPacks, misma regla que snippets/vb-pack-price.liquid)
   · vista previa de precios de pack solo en un tema sin publicar · seguimiento con cuenta atrás en vivo (zona horaria del
   ajuste, días hábiles sin sábados, domingos ni festivos configurables) · preguntas con respuesta fija y efecto de
   escritura · Combínalo (propiedad _upsell para la futura Discount Function) · barra fija que aparece al pasar el botón.
   El envío del formulario lo hace vb.js (data-vb-product-form → VB.cart.add → abre el carrito). */
if (!customElements.get('vb-product')) {
  const fm = (c) => (window.VB && VB.formatMoney ? VB.formatMoney(c) : `${(c / 100).toFixed(2).replace('.', ',')} €`);
  const RM = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Respaldo idéntico a window.VBPacks (assets/component-product-card.js) por si esa hoja no cargó */
  const PK = window.VBPacks || (window.VBPacks = {
    parse: (s) => {
      const [p, f] = String(s || '').split('|');
      const m = String(p || '').split(',').map((x) => { const [q, v] = x.split(':'); return String(v || '')[0] === '=' ? [Number(q), 0, Number(v.slice(1))] : [Number(q), Number(v)]; }).filter(([q, d, t]) => q > 0 && (t > 0 || (d > 0 && d < 100)));
      m.r99 = f === '99';
      return m;
    },
    pack: (k, d, unit, r99, t0) => {
      const base = k * unit;
      if (t0 > 0) return t0 < base ? t0 : base;
      let t = base - Math.round((base * d) / 100);
      if (r99) t = Math.round(t / 100) * 100 - 1;
      return t < base ? t : base;
    },
    total: (map, q, unit) => map.reduce((b, [kq, d, t]) => (kq <= q ? Math.min(b, window.VBPacks.pack(kq, d, unit, map.r99, t) + (q - kq) * unit) : b), q * unit),
  });
  /* Tema sin publicar (preview / editor): mismo criterio que «Enlaces de QA» de assets/vb.js */
  const PREVIEW = !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');

  customElements.define('vb-product', class extends HTMLElement {
    connectedCallback() {
      if (this.__init) return;
      this.__init = true;
      this.price = Number(this.dataset.price || 0);
      this.compare = Number(this.dataset.compare || 0);
      this.map = PK.parse(this.dataset.packMap);
      // Precios de pack apagados: se enseñan solo en un tema sin publicar; publicado = comportamiento OFF
      if (!this.map.length && PREVIEW && this.dataset.packMapPreview) {
        this.map = PK.parse(this.dataset.packMapPreview);
        if (this.map.length) {
          document.documentElement.classList.add('vb-pk-preview');
        }
      }
      this.min = Math.max(1, Number(this.dataset.min || 1));
      this.form = this.querySelector('[data-main-form]');
      this.qtyInput = this.querySelector('[data-qty-input]');
      this.opts = [...this.querySelectorAll('.vb-pdp__opt')];
      const act = this.opts.find((b) => b.classList.contains('is-active'));
      this.pq = Math.max(this.min, Number((act && act.dataset.packQ) || this.dataset.packQ || this.min));
      this.disc = Number((act && act.dataset.packDisc) || 0);
      this.n = 1;
      // Selector de cantidad (ajuste show_qty): apagado = siempre 1 pack, sin − 1 + en la ficha ni en la barra fija
      this.qtyOn = this.dataset.showQty === 'true';
      this.label = act ? act.dataset.packLabel : '';
      this.satc = document.querySelector(`[data-satc="${this.dataset.section}"]`);
      this.gallery();
      this.lightbox();
      this.bindBuy();
      this.cod();
      {
        const q = parseInt(new URLSearchParams(location.search).get('cantidad'), 10);
        if (q > 1) {
          const o = this.opts.find((b) => Number(b.dataset.packQ) === q);
          if (o) this.setPack(o); else this.setN(Math.max(1, Math.round(q / this.pq)));
        }
      }
      this.render();
      this.tracker();
      this.ai();
      this.accs();
      this.upsell();
      this.sticky();
    }

    disconnectedCallback() {
      clearTimeout(this.trkStep);
      clearInterval(this.trkTick);
      this.trkIO?.disconnect();
      if (this.onLbResize) window.removeEventListener('resize', this.onLbResize);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.satc?.remove();
      this.lb?.remove();
      document.documentElement.classList.remove('vb-lb-open');
    }

    /* Galería ----------------------------------------------------------- */
    gallery() {
      const track = this.querySelector('[data-gtrack]');
      if (!track) return;
      const slides = [...track.children];
      const thumbs = [...this.querySelectorAll('[data-thumb]')];
      const dots = [...this.querySelectorAll('.vb-pdp__dots i')];
      const prev = this.querySelector('[data-gprev]');
      const next = this.querySelector('[data-gnext]');
      const cur = () => Math.round(track.scrollLeft / (track.clientWidth || 1));
      const go = (i, instant) => {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: instant || RM() || document.hidden ? 'auto' : 'smooth' });
      };
      const sync = () => {
        const c = cur();
        thumbs.forEach((b, j) => { b.classList.toggle('is-active', j === c); if (j === c) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
        dots.forEach((d, j) => d.classList.toggle('is-active', j === c));
        // Regla iUROP: al inicio solo la flecha derecha; al final desaparece
        if (prev) prev.hidden = c <= 0;
        if (next) next.hidden = c >= slides.length - 1;
        const t = thumbs[c];
        if (t && t.parentElement.scrollHeight > t.parentElement.clientHeight) {
          const p = t.parentElement;
          if (t.offsetTop < p.scrollTop || t.offsetTop + t.offsetHeight > p.scrollTop + p.clientHeight) p.scrollTo({ top: t.offsetTop - 10, behavior: 'smooth' });
        }
      };
      let raf = 0;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
      thumbs.forEach((b) => b.addEventListener('click', () => go(Number(b.dataset.thumb))));
      prev?.addEventListener('click', () => go(cur() - 1));
      next?.addEventListener('click', () => go(cur() + 1));
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur() - 1); }
      });
      if (window.VB && VB.drag && slides.length > 1) VB.drag(track);
      this.gGo = go;
      this.gCur = cur;
      sync();
    }

    /* Visor a pantalla completa -------------------------------------------- */
    lightbox() {
      const dlg = this.querySelector('[data-lb]');
      const main = this.querySelector('[data-gtrack]');
      if (!dlg || !main || typeof dlg.showModal !== 'function') return;
      if (dlg.parentElement !== document.body) document.body.appendChild(dlg); // fuera de transforms/animaciones de la sección
      this.lb = dlg;
      const html = document.documentElement;
      const track = dlg.querySelector('[data-lb-track]');
      const slides = [...track.children];
      const imgs = slides.map((li) => li.querySelector('img'));
      const count = dlg.querySelector('[data-lb-count]');
      const prev = dlg.querySelector('[data-lb-prev]');
      const next = dlg.querySelector('[data-lb-next]');
      const n = slides.length;
      const idx = () => Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
      const go = (i) => {
        i = Math.max(0, Math.min(n - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: RM() || document.hidden ? 'auto' : 'smooth' });
      };
      const sync = () => {
        const c = idx();
        if (count) count.textContent = `${c + 1} / ${n}`;
        if (prev) prev.hidden = c <= 0;
        if (next) next.hidden = c >= n - 1;
        [c - 1, c, c + 1].forEach((k) => { if (imgs[k]) imgs[k].loading = 'eager'; });
      };
      let raf = 0;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
      // Precarga en serie del resto (una a una, en reposo) para que pasar de foto no deje huecos
      const warm = () => {
        const todo = imgs.filter((im) => im && im.loading !== 'eager');
        const step = () => {
          const im = todo.shift();
          if (!im || !dlg.open) return;
          im.loading = 'eager';
          if (im.complete) step(); else { im.addEventListener('load', step, { once: true }); im.addEventListener('error', step, { once: true }); }
        };
        (window.requestIdleCallback || ((f) => setTimeout(f, 200)))(step);
      };
      const open = (i) => {
        // Mientras carga la grande se ve al instante la del carrusel ya decodificada (fondo del mismo encuadre). En cuanto la
        // grande está lista el fondo se quita: si no, fondo «contain» e <img> (cajas de tamaño distinto) = dos fotos.
        main.querySelectorAll('.vb-pdp__img').forEach((im, k) => {
          const li = slides[k];
          const big = imgs[k];
          if (!li) return;
          const clear = () => { li.style.backgroundImage = ''; li.classList.remove('is-ph'); };
          if (!big || (big.complete && big.naturalWidth)) { clear(); return; }
          const src = im.currentSrc || im.src;
          if (src && im.complete && !li.style.backgroundImage) {
            li.style.backgroundImage = `url("${src}")`;
            li.classList.add('is-ph');
            big.addEventListener('load', clear, { once: true });
            big.addEventListener('error', clear, { once: true });
          }
        });
        imgs.forEach((im, k) => { if (im && Math.abs(k - i) <= 1) im.loading = 'eager'; });
        html.classList.add('vb-lb-open');
        dlg.classList.remove('is-closing');
        dlg.showModal();
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = i * track.clientWidth;
        requestAnimationFrame(() => { track.scrollLeft = i * track.clientWidth; track.style.scrollBehavior = ''; sync(); });
        dlg.querySelector('[data-lb-close]')?.focus({ preventScroll: true });
        warm();
      };
      let closing = false;
      let last = 0; // índice al cerrar (con el diálogo cerrado el track no mide)
      const close = () => {
        if (!dlg.open || closing) return;
        last = idx();
        if (RM() || document.hidden) { dlg.close(); return; }
        closing = true;
        dlg.classList.add('is-closing');
        setTimeout(() => { closing = false; dlg.close(); }, 200);
      };
      dlg.addEventListener('close', () => {
        dlg.classList.remove('is-closing');
        html.classList.remove('vb-lb-open');
        const c = last;
        // La galería de la ficha queda en la misma foto y el foco vuelve a su botón de ampliar
        if (this.gGo) this.gGo(c, true);
        const btn = main.querySelector(`[data-lb-open="${c}"]`);
        btn?.focus({ preventScroll: true });
      });
      dlg.addEventListener('cancel', (e) => { e.preventDefault(); close(); }); // Esc con la misma salida suave
      dlg.addEventListener('click', (e) => {
        if (e.target.closest('[data-lb-close]')) { close(); return; }
        if (e.target.closest('[data-lb-prev]')) { go(idx() - 1); return; }
        if (e.target.closest('[data-lb-next]')) { go(idx() + 1); return; }
        // Fondo: el propio diálogo o la diapositiva fuera de la foto
        if (e.target === dlg || e.target.classList.contains('vb-lb__slide') || e.target === track) close();
      });
      dlg.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(idx() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx() - 1); }
      });
      this.onLbResize = () => { if (dlg.open) { track.style.scrollBehavior = 'auto'; track.scrollLeft = idx() * track.clientWidth; track.style.scrollBehavior = ''; } };
      window.addEventListener('resize', this.onLbResize, { passive: true });
      if (window.VB && VB.drag && n > 1) VB.drag(track);
      // Clic/tap en la foto de la ficha (tras un arrastre con ratón, VB.drag anula el clic)
      main.addEventListener('click', (e) => {
        const b = e.target.closest('[data-lb-open]');
        if (b) open(Number(b.dataset.lbOpen) || 0);
      });
    }

    /* Contra reembolso: sin el embed de Releasit el aviso queda como texto informativo (no un botón muerto) */
    /* Contra reembolso: con el embed de Releasit (html.vb-cod-on) el botón abre su formulario. Sin él, publicado, el aviso
       y el sello COD siguen tras la puerta data-vb-cod-gate (ocultos por assets/vb-cod.css); en un tema sin publicar se
       enseñan como texto informativo para revisar el diseño. */
    cod() {
      if (document.documentElement.classList.contains('vb-cod-on')) return;
      const btn = this.querySelector('button.vb-pdp__cod');
      let p = null;
      if (btn) {
        p = document.createElement('p');
        p.className = 'vb-pdp__cod';
        p.setAttribute('data-vb-cod-gate', '');
        p.innerHTML = btn.innerHTML;
        btn.replaceWith(p);
      }
      if (!PREVIEW) return;
      if (p) p.removeAttribute('data-vb-cod-gate');
      this.querySelectorAll('.vb-pdp__seals > li[data-vb-cod-gate]').forEach((el) => el.removeAttribute('data-vb-cod-gate'));
    }

    /* Pack + cantidad + precio ------------------------------------------ */
    bindBuy() {
      this.addEventListener('click', (e) => {
        const o = e.target.closest('.vb-pdp__opt');
        if (o && this.contains(o)) { this.setPack(o); return; }
        const q = e.target.closest('[data-qty]');
        if (q && this.contains(q)) this.setN(this.n + Number(q.dataset.qty));
      });
      const sel = this.querySelector('select[data-variant-input]');
      sel?.addEventListener('change', () => {
        const op = sel.selectedOptions[0];
        this.price = Number(op.dataset.price || this.price);
        this.compare = Number(op.dataset.compare || 0);
        this.render();
      });
      this.form?.addEventListener('submit', () => { const err = this.form.querySelector('[data-vb-form-error]'); if (err) err.hidden = true; }, true);
    }

    // Elegir pack NO toca la cantidad (nº de packs) y subir la cantidad NO cambia de pack
    setPack(opt) {
      this.opts.forEach((b) => { const on = b === opt; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', String(on)); });
      this.pq = Math.max(this.min, Number(opt.dataset.packQ) || this.min);
      this.disc = Number(opt.dataset.packDisc || 0);
      this.label = opt.dataset.packLabel || '';
      const name = this.querySelector('[data-pack-name]');
      if (name) name.textContent = this.label;
      this.render();
    }

    setN(n) {
      if (!this.qtyOn) n = 1;
      this.n = Math.max(1, Math.min(Math.floor(99 / this.pq) || 1, n || 1));
      this.render();
    }

    // Total de q unidades (precio de pack de la tabla, o descuento % de la columna 4) y su tachado
    // fixedWas: tachado fijo de la línea del pack (5.ª columna, data-pack-was) → gana al calculado
    packPrice(q, disc, fixedWas) {
      const base = this.price * q;
      if (this.map.length) return { now: PK.total(this.map, q, this.price), was: fixedWas > 0 ? fixedWas : (this.compare > this.price ? this.compare : this.price) * q };
      const now = base - Math.floor((base * (disc || 0)) / 100);
      let was = this.compare * q;
      if (disc > 0 && was <= now) was = base;
      if (fixedWas > 0) was = fixedWas;
      return { now, was };
    }

    render() {
      const act = this.opts.find((b) => b.classList.contains('is-active'));
      const one = this.packPrice(this.pq, this.disc, Number((act && act.dataset.packWas) || 0));
      // Total de n packs = misma regla que la Function y window.VBPacks: tramo más alto una vez + el resto como sueltas
      const now = this.map.length ? PK.total(this.map, this.pq * this.n, this.price) : one.now * this.n;
      const was = one.was * this.n;
      const off = was > now ? Math.round((1 - now / was) * 100) : 0;
      const $ = (s) => this.querySelector(s);
      if (this.qtyInput) this.qtyInput.value = this.pq * this.n;
      const qv = $('[data-qty-value]'); if (qv) qv.textContent = this.n;
      const minus = $('[data-qty="-1"]'); if (minus) minus.disabled = this.n <= 1;
      const pn = $('[data-p-now]'); if (pn) pn.textContent = fm(now);
      const pw = $('[data-p-was]'); if (pw) { pw.textContent = fm(was); pw.hidden = !(was > now); }
      const po = $('[data-p-off]'); if (po) { po.textContent = (this.dataset.offTpl || '−[pct]%').replace('[pct]', off); po.hidden = off <= 0; }
      this.querySelectorAll('[data-atc-price]').forEach((el) => (el.textContent = fm(now)));
      // Cada opción: precio de UN pack, tachado y «Ahorra X%» calculados de la tabla de packs
      const tpl = this.dataset.saveTpl || 'Ahorra [pct]%';
      this.opts.forEach((b) => {
        const p = this.packPrice(Number(b.dataset.packQ), Number(b.dataset.packDisc || 0), Number(b.dataset.packWas || 0));
        const o = p.was > p.now ? Math.round((1 - p.now / p.was) * 100) : 0;
        const bn = b.querySelector('[data-o-now]'); if (bn) bn.textContent = fm(p.now);
        const bw = b.querySelector('[data-o-was]'); if (bw) { bw.textContent = fm(p.was); bw.hidden = o <= 0; }
        const bs = b.querySelector('[data-o-save]'); if (bs) { bs.textContent = tpl.replace('[pct]', o); bs.hidden = o <= 0; }
      });
      const units = this.pq * this.n;
      const label = this.label || (this.dataset.unitsTpl || '[n] unidades').replace('[n]', units).replace(units === 1 ? /^1 unidades$/ : /$^/, '1 unidad');
      const full = this.n > 1 && this.label ? (this.dataset.timesTpl || '[pack] × [n]').replace('[pack]', this.label).replace('[n]', this.n) : label;
      if (this.satc) {
        this.satc.querySelectorAll('[data-satc-price]').forEach((el) => (el.textContent = fm(now)));
        const sq = this.satc.querySelector('[data-satc-qty-value]'); if (sq) sq.textContent = this.n;
        const sp = this.satc.querySelector('[data-satc-pack]'); if (sp) sp.textContent = full;
      }
    }

    /* Seguimiento estimado ---------------------------------------------- */
    tracker() {
      const box = this.querySelector('[data-trk]');
      if (!box) return;
      let steps = [];
      try { steps = JSON.parse(box.querySelector('[data-trk-steps]').textContent); } catch (e) { return; }
      const d = box.dataset;
      const tz = d.tz || 'Europe/Madrid';
      const cutoff = Number(d.cutoff || 14) * 60 + Number(d.cutoffMin || 0); // minutos del día
      const aMax = Math.max(1, Number(d.arrive || 2));
      const aMin = Math.max(1, Math.min(aMax, Number(d.arriveMin || aMax)));
      const list2 = (s) => String(s || '').split(/[\s,]+/).map((x) => x.trim().toLowerCase()).filter(Boolean);
      const hol = list2(d.holidays);
      const closed = list2(d.closed);
      const DAYS = (d.days || 'dom,lun,mar,mié,jue,vie,sáb').split(',').map((x) => x.trim());
      const MONTHS = (d.months || 'ene,feb,mar,abr,may,jun,jul,ago,sep,oct,nov,dic').split(',').map((x) => x.trim());
      const pad = (v) => String(v).padStart(2, '0');
      // Fechas «de pared» de la zona horaria del ajuste, en UTC para operar sin desfases (nunca toISOString de la hora local)
      const wall = () => {
        const p = new Intl.DateTimeFormat('en-GB', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
          .formatToParts(new Date()).reduce((a, x) => ((a[x.type] = x.value), a), {});
        return { date: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), sec: (+p.hour % 24) * 3600 + +p.minute * 60 + +p.second };
      };
      const ymd = (x) => `${x.getUTCFullYear()}-${pad(x.getUTCMonth() + 1)}-${pad(x.getUTCDate())}`;
      const easter = (y) => { // algoritmo gregoriano anónimo
        const a = y % 19, b = Math.floor(y / 100), c = y % 100, e1 = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
          h = (19 * a + b - e1 - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
          mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
        return new Date(Date.UTC(y, mo - 1, da));
      };
      const hcache = {};
      const holidaysOf = (y) => {
        if (hcache[y]) return hcache[y];
        const out = [];
        hol.forEach((h) => {
          if (h === 'viernes-santo') { const gf = easter(y); gf.setUTCDate(gf.getUTCDate() - 2); out.push(ymd(gf)); }
          else if (/^\d{2}-\d{2}$/.test(h)) out.push(`${y}-${h}`);
          else if (/^\d{4}-\d{2}-\d{2}$/.test(h)) out.push(h);
        });
        return (hcache[y] = out);
      };
      const isBiz = (x) => { const w = x.getUTCDay(); const k = ymd(x); return w !== 0 && w !== 6 && !holidaysOf(x.getUTCFullYear()).includes(k) && !closed.includes(k); };
      const addBiz = (x, n) => { const r = new Date(x); while (n > 0) { r.setUTCDate(r.getUTCDate() + 1); if (isBiz(r)) n--; } return r; };
      const short = (x) => `${DAYS[x.getUTCDay()] || ''} ${x.getUTCDate()} ${MONTHS[x.getUTCMonth()] || ''}`.trim();
      const range = (a, b) => {
        if (ymd(a) === ymd(b)) return short(a);
        if (a.getUTCMonth() === b.getUTCMonth()) return `${DAYS[a.getUTCDay()]} ${a.getUTCDate()} – ${short(b)}`;
        return `${short(a)} – ${short(b)}`;
      };
      const calc = () => {
        const w = wall();
        const before = isBiz(w.date) && w.sec < cutoff * 60;
        const ship = before ? w.date : addBiz(w.date, 1);
        const diff = Math.round((ship - w.date) / 864e5);
        const shipTxt = before ? (d.today || 'hoy') : diff === 1 ? (d.tomorrow || 'mañana') : (d.dateTpl || 'el [fecha]').replace('[fecha]', short(ship));
        const left = Math.max(0, cutoff * 60 - w.sec);
        return { before, shipTxt, arrive: range(addBiz(ship, aMin), addBiz(ship, aMax)), h: Math.floor(left / 3600), m: Math.floor((left % 3600) / 60), s: left % 60 };
      };
      const esc = (t) => String(t || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      // Solo se permite <b> en los títulos; [h] [m] [s] = cifras vivas que se animan al cambiar
      const rich = (t) => esc(t).replace(/&lt;(\/?)b&gt;/g, '<$1b>')
        .replace('[h]', '<span class="vb-pdp__cd" data-cd="h"></span>').replace('[m]', '<span class="vb-pdp__cd" data-cd="m"></span>').replace('[s]', '<span class="vb-pdp__cd" data-cd="s"></span>');
      const fill = (t, st) => String(t || '').replace('[salida]', st.shipTxt).replace('[llegada]', st.arrive);
      let st = calc();
      const build = () => steps.map((s, i) => ({ ic: s.ic, t: fill(i === 0 && st.before && s.tb ? s.tb : s.t, st), s: fill(i === 0 && st.before && s.sb ? s.sb : s.s, st), n: fill(s.n, st) }));
      let list = build();
      const icons = {};
      box.querySelector('[data-trk-icons]')?.content.querySelectorAll('[data-ic]').forEach((el) => (icons[el.dataset.ic] = el.innerHTML));
      const tile = box.querySelector('[data-trk-tile]');
      const text = box.querySelector('[data-trk-text]');
      const knob = box.querySelector('[data-trk-knob]');
      const segs = [...box.querySelectorAll('.vb-pdp__trk-seg')];
      const tick = (animate) => {
        const vals = { h: String(st.h), m: pad(st.m), s: pad(st.s) };
        text.querySelectorAll('[data-cd]').forEach((el) => {
          const v = vals[el.dataset.cd];
          if (el.textContent === v) return;
          el.textContent = v;
          if (animate && !RM()) { el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick'); }
        });
      };
      let k = 0;
      const paint = (animate) => {
        const s = list[k];
        const put = () => {
          tile.innerHTML = icons[s.ic] || tile.innerHTML;
          text.innerHTML = `<strong>${rich(s.t)}</strong><span>${esc(s.s)}</span><small>${esc(s.n)}</small>`;
          tick(false);
          tile.classList.remove('is-out'); text.classList.remove('is-out');
        };
        if (animate) { tile.classList.add('is-out'); text.classList.add('is-out'); setTimeout(put, 240); } else put();
        segs.forEach((sg, j) => { sg.classList.toggle('is-done', j < k); sg.classList.toggle('is-run', j === k); });
        if (knob) {
          // Centrada en el hueco que hay antes de la barra k (el primero es el margen izquierdo de la barra)
          const gap = parseFloat(getComputedStyle(knob.parentElement).columnGap) || 40;
          knob.style.left = k && segs[k] ? `${segs[k].offsetLeft - gap / 2 - knob.offsetWidth / 2}px` : '4px';
        }
      };
      paint(false);
      // Reloj: cada segundo; si pasa la hora límite con la página abierta, cambian textos y fechas
      // Pausado con la pestaña oculta o el seguimiento fuera de pantalla
      let onScreen = true;
      if ('IntersectionObserver' in window) { this.trkIO = new IntersectionObserver(([e]) => { onScreen = e.isIntersecting; }); this.trkIO.observe(box); }
      this.trkTick = setInterval(() => {
        if (document.hidden || !onScreen) return;
        const was = st.before;
        st = calc();
        if (st.before !== was) { list = build(); paint(false); } else tick(true);
      }, 1000);
      if (RM() || list.length < 2) return;
      box.classList.add('is-live');
      const dwell = Math.max(2, Number(d.dwell || 4)) * 1000;
      const next = () => {
        const ms = k === 0 ? dwell * 2 : dwell;
        segs.forEach((sg) => sg.style.setProperty('--trk-ms', `${ms}ms`));
        this.trkStep = setTimeout(() => {
          if (!document.hidden) {
            k = (k + 1) % list.length;
            segs.forEach((sg) => { const i = sg.querySelector('i'); i.style.animation = 'none'; void i.offsetWidth; i.style.animation = ''; });
            paint(true);
          }
          next();
        }, ms);
      };
      segs.forEach((sg) => sg.style.setProperty('--trk-ms', `${dwell * 2}ms`));
      next();
    }

    /* Desplegables: abrir/cerrar con altura + opacidad (WAAPI, funciona en Safari). El <summary> sigue siendo el control
       nativo (Enter/Espacio = clic); reducción de movimiento o pestaña oculta = comportamiento nativo sin animación. */
    accs() {
      const EASE = 'cubic-bezier(.22, 1, .36, 1)';
      const MS = 300;
      this.querySelectorAll('details.vb-pdp__acc').forEach((d) => {
        const sum = d.querySelector(':scope > summary');
        const body = d.querySelector(':scope > .vb-pdp__acc-body');
        if (!sum || !body || typeof d.animate !== 'function') return;
        let hA = null, oA = null;
        sum.addEventListener('click', (e) => {
          if (RM() || document.hidden) return;
          e.preventDefault();
          const closing = d.classList.contains('is-closing');
          const opening = !d.open || closing;
          const start = d.getBoundingClientRect().height;
          const op0 = Number(getComputedStyle(body).opacity);
          hA?.cancel(); oA?.cancel();
          d.classList.remove('is-closing');
          d.open = true;
          const end = opening ? d.getBoundingClientRect().height : sum.getBoundingClientRect().height + (d.offsetHeight - d.clientHeight);
          if (!opening) d.classList.add('is-closing');
          d.style.overflow = 'hidden';
          d.style.boxSizing = 'border-box';
          hA = d.animate({ height: [`${start}px`, `${end}px`] }, { duration: MS, easing: EASE, fill: 'forwards' }); // forwards: sin fotograma a altura completa antes de quitar [open]
          oA = body.animate({ opacity: [opening ? (closing ? op0 : 0) : op0, opening ? 1 : 0] }, { duration: opening ? MS : MS * 0.7, easing: EASE, fill: 'forwards' });
          const a = hA;
          const done = () => {
            if (a !== hA) return;
            if (!opening) d.open = false;
            d.classList.remove('is-closing');
            d.style.overflow = ''; d.style.boxSizing = '';
            a.cancel(); oA?.cancel();
            hA = oA = null;
          };
          hA.onfinish = done;
          // Red de seguridad: si el navegador no avanza la animación (pestaña en segundo plano, ahorro de energía),
          // el desplegable termina igual de abrirse/cerrarse
          setTimeout(done, MS + 120);
        });
      });
    }

    /* Preguntas rápidas -------------------------------------------------- */
    ai() {
      const root = this.querySelector('[data-ai-root]');
      if (!root) return;
      const box = root.querySelector('[data-ai-box]');
      const txt = box.querySelector('[data-ai-txt]');
      const recBox = box.querySelector('[data-ai-recbox]');
      const note = box.querySelector('[data-ai-note]');
      const typing = root.dataset.typing === 'true' && !RM();
      let run = 0;
      const close = () => {
        run++;
        box.hidden = true;
        root.querySelectorAll('[data-ai]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      };
      const open = (btn) => {
        const i = btn.dataset.ai;
        if (btn.getAttribute('aria-expanded') === 'true') { close(); btn.focus(); return; }
        const id = ++run;
        root.querySelectorAll('[data-ai]').forEach((b) => b.setAttribute('aria-expanded', String(b === btn)));
        btn.after(box);
        box.hidden = false;
        recBox.innerHTML = '';
        if (note) note.hidden = true;
        const answer = (root.querySelector(`[data-ai-a="${i}"]`)?.content.textContent || '').trim();
        const rec = root.querySelector(`[data-ai-rec="${i}"]`);
        const finish = () => {
          if (id !== run) return;
          txt.textContent = answer;
          if (rec) recBox.append(rec.content.cloneNode(true));
          if (note) note.hidden = false;
        };
        if (!typing) { finish(); return; }
        txt.innerHTML = '<span class="vb-pdp__ai-dots" aria-hidden="true"><i></i><i></i><i></i></span>';
        const words = answer.split(' ');
        setTimeout(() => {
          let n = 0;
          const tick = () => {
            if (id !== run) return;
            txt.textContent = words.slice(0, ++n).join(' ');
            if (n < words.length) setTimeout(tick, 28); else finish();
          };
          tick();
        }, 650);
      };
      root.addEventListener('click', (e) => {
        const q = e.target.closest('[data-ai]');
        if (q) { open(q); return; }
        if (e.target.closest('[data-ai-x]')) {
          const b = root.querySelector('[data-ai][aria-expanded="true"]');
          close();
          b?.focus();
        }
      });
    }

    /* Combínalo ----------------------------------------------------------- */
    upsell() {
      const root = this.querySelector('[data-upsell]') || this;
      if (!root) return;
      const main = () => Number(this.querySelector('[data-variant-input]')?.value);
      const err = root.querySelector('[data-up-error]');
      // Vista previa del descuento (Figma 23737:1804): con «Descuentos activos» apagado, solo en un tema sin publicar
      if (PREVIEW && root.dataset.preview === 'true' && root.dataset.on !== 'true') {
        const pct = Number(root.dataset.pct) || 0;
        const all = Number(root.dataset.allPct) || 0;
        // descuento redondeado al céntimo, producto a producto (= Discount Function): 29,99 −5 % = 28,49 · 3 × 29,99 −10 % = 80,97
        const cut = (c, p) => c - Math.floor((c * p) / 100); // Shopify trunca el descuento por producto
        const title = root.querySelector('[data-up-title]');
        if (title && root.dataset.titlePrev) title.innerHTML = root.dataset.titlePrev;
        const rows = [...root.querySelectorAll('.vb-pdp__up-item:not(.vb-pdp__up-item--ai)')];
        if (pct > 0) rows.forEach((it) => {
          const c = Number(it.dataset.upPrice) || 0;
          const now = it.querySelector('[data-up-now]'); const was = it.querySelector('[data-up-was]');
          if (!c || !now || !was) return;
          now.textContent = fm(cut(c, pct)); was.textContent = fm(c); was.hidden = false;
        });
        const sum = Number(root.dataset.upSum) || 0;
        const tot = root.querySelector('[data-up-total]'); const tw = root.querySelector('[data-up-total-was]');
        if (all > 0 && sum && tot && tw) {
          const prices = rows.map((it) => Number(it.dataset.upPrice) || 0);
          const mainP = sum - prices.reduce((a, b) => a + b, 0); // up_sum = ficha + sugeridos
          // Total como los códigos VBCOMBO10<PRODUCTO> de Shopify: % truncado en cada producto
          const list = [mainP, ...prices];
          const tsum = list.reduce((a, c) => a + c, 0);
          tot.textContent = fm(tsum - list.reduce((a, c) => a + Math.floor((c * all) / 100), 0)); tw.textContent = fm(sum); tw.hidden = false;
        }
        root.classList.add('is-preview');
      }
      const add = async (btn, ids, tag) => {
        if (!window.VB || !VB.cart) return;
        btn.classList.add('is-loading');
        if (err) err.hidden = true;
        try {
          // El producto de la ficha va con la misma marca para que la futura función aplique el descuento al conjunto
          let cart = null;
          try { cart = await fetch(`${(VB.routes && VB.routes.cart) || '/cart'}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()); } catch (e) { cart = null; }
          // El de la ficha solo se añade si aún no está en el carrito (no se duplica lo que ya lleva)
          const inCart = (id) => !!(cart && cart.items && cart.items.some((it) => it.variant_id === id));
          // Una unidad de cada uno, también el de la ficha aunque su ficha empiece en Pack 2 («Llévate los tres por …» = 1 + 1 + 1)
          const items = [main(), ...ids].filter((id, i, a) => id && a.indexOf(id) === i && (i > 0 || !inCart(id))).map((id) => ({ id, quantity: 1, properties: tag === 'item' && id === main() ? {} : { _upsell: tag } }));
          // «+» de un sugerido: la ficha anuncia el sugerido rebajado y el de la ficha a su precio → solo el sugerido
          // lleva la marca (código VBCOMBO5<PRODUCTO>); con «Añadir todo» van los tres rebajados, como dice el pie
          if (items.length) await VB.cart.add(items); else VB.cart.open();
          btn.classList.add('is-done');
        } catch (e) {
          if (err) { err.textContent = e.message; err.hidden = false; }
        } finally {
          btn.classList.remove('is-loading');
        }
      };
      this.addEventListener('click', (e) => {
        const one = e.target.closest('[data-up-add]');
        // _upsell = «item» (% por producto) o «all» (% de Añadir todo): la Discount Function lee el % de su configuración
        if (one && this.contains(one)) { add(one, [Number(one.dataset.upAdd)], 'item'); return; }
        const all = e.target.closest('[data-up-all]');
        if (all && this.contains(all)) add(all, [...root.querySelectorAll('[data-up-add]')].map((b) => Number(b.dataset.upAdd)), 'all');
      });
    }

    /* Barra fija ----------------------------------------------------------- */
    sticky() {
      const bar = this.satc;
      if (!bar) return;
      if (bar.parentElement !== document.body) document.body.appendChild(bar);
      if (!this.qtyOn) bar.classList.add('vb-satc--noqty');
      bar.addEventListener('click', (e) => {
        const q = e.target.closest('[data-satc-qty]');
        if (q && this.qtyOn) this.setN(this.n + Number(q.dataset.satcQty));
        if (e.target.closest('[data-satc-add]') && this.form) this.form.requestSubmit ? this.form.requestSubmit() : this.form.submit();
      });
      const btn = this.querySelector('[data-main-atc]');
      const footer = document.querySelector('.vb-footer') || document.querySelector('footer');
      let on = false, past = false, near = false;
      this.onScroll = () => {
        if (!btn) return;
        const b = btn.getBoundingClientRect();
        past = past ? b.bottom < 40 : b.bottom < 0;
        if (footer) { const ft = footer.getBoundingClientRect().top; near = near ? ft < innerHeight + 40 : ft < innerHeight; }
        const v = past && !near;
        if (v === on) return;
        on = v;
        bar.classList.toggle('is-visible', on);
        bar.toggleAttribute('inert', !on);
        bar.setAttribute('aria-hidden', String(!on));
        document.body.classList.toggle('vb-satc-visible', on);
        if (!on && bar.contains(document.activeElement)) document.activeElement.blur();
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();
    }
  });
}
